/* eslint-disable */
import axios from "axios"

export default {
  methods: {
    /**
     * Traz combo de Complexidades
     */
    getComplexidades(form_name) {
      return axios.get(
        this.CriarUrl({
          resource: `complexidade?rnpTipoFormulario=${form_name}`
        })
      );
    }
  }
}